module.exports = __webpack_public_path__ + "img/no-passport-photo.3ce2e4c8.jpg";